<zci-tile
    [navOverflowMenuConfig]="navOverflowMenuConfig"
    [isRequestPending]="false"
    data-cy="user-tile">
    <a class="c11n-space-stack-1x zci-text--bold">
        {{ usrName }}
    </a>
    <div *ngIf="isInternal" class="d-flex flex-wrap">
        <c11n-chip size="small" color="internal" action="none" labelText="Internal only: Client ID {{ poid }}" class="me-2 mb-2"></c11n-chip>
        <c11n-chip *ngIf="isHsgRecipient" size="small" color="internal" action="none" labelText="Internal only: HSG Recipient" class="mb-2"></c11n-chip>
    </div>
    <a *ngIf="!hasSelectedAccount" class="c11n-space-stack-1x">
        {{ accName }}
    </a>
    <p *ngIf="!hasSelectedAccount" class="c11n-space-stack-1x">
        {{ accType | mapAccType }}
    </p>
    <p class="c11n-space-stack-1x zci-text--disabled zci-text--bold">
        {{ roleType | mapRoleType }}
    </p>
</zci-tile>
